import { createContext } from 'react';
import type { PromotionBrandScope } from './promotionBrandScopeTypes';

export const PromotionBrandContext = createContext<PromotionBrandScope | null>(null);
